import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  processLine: null,
  eklok: null,
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "eklokLineStatus",
  initialState: initialState,
  reducers: {
    initConnectionLineStatus: (state, action) => {
      state.loading = true;
      state.eklok = null;
      state.error = null;
      state.processLine = null;
    },
    successConnectionLineStatus: (state, action) => {
      state.loading = false;
      state.eklok =
        action.payload.body.line_status && action.payload.body.eklok;
      state.error = null;
      state.processLine = action.payload.body.processLine;
    },
    setConnectionLineStatusError: (state, action) => {
      state.error = action.payload;
      state.eklok = null;
      state.processLine = null;
      state.loading = false;
    },
    connectionLineStatusResetState: () => initialState,
  },
});

export const {
  initConnectionLineStatus,
  successConnectionLineStatus,
  setConnectionLineStatusError,
  connectionLineStatusResetState,
} = slice.actions;

export default slice.reducer;
